import { render, staticRenderFns } from "./TermChip.vue?vue&type=template&id=618ed25e"
import script from "./TermChip.vue?vue&type=script&lang=js"
export * from "./TermChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports